import { Chip } from "@mui/joy";
import { TaskStatus } from "griptonite-api-client/types/tasks";

type Props = {
  status?: TaskStatus;
};

const bgColorsMap = {
  TODO: "#F7E5FF",
  IN_PROGRESS: "#E5FEFF",
  DONE: "#D7FFCD",
};
const fgColorsMap = {
  TODO: "#010024",
  IN_PROGRESS: "#010024",
  DONE: "#1F9A00",
};

const labelsMap = {
  TODO: "Todo",
  IN_PROGRESS: "In progress",
  DONE: "Done",
};

export const getStatusLabel = (status: TaskStatus) => labelsMap[status];

export default function StatusChip({ status }: Props) {
  if (!status) {
    return null;
  }
  return (
    <Chip
      size="sm"
      sx={{
        color: fgColorsMap[status],
        backgroundColor: bgColorsMap[status],
        fontWeight: "bold",
        fontSize: "sm",
      }}
    >
      {getStatusLabel(status)}
    </Chip>
  );
}
